import { Flex, Text, Wrap, WrapItem } from "@chakra-ui/react";
import React from "react";
import { brandPalette } from "../../../constants/brandPalette";

const VariableChips = ({ variables = [] }) => {
  if (!variables.length) {
    return (
      <Text fontSize="sm" color="var(--text-muted)">
        No placeholders detected in body content.
      </Text>
    );
  }

  return (
    <Wrap spacing={2}>
      {variables.map((name) => (
        <WrapItem key={name}>
          <Flex
            px={3}
            py={1}
            borderRadius="md"
            bg="rgba(91, 13, 22, 0.08)"
            border="1px solid"
            borderColor={brandPalette.stone}
            fontFamily="ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace"
            fontSize="sm"
            color={brandPalette.primary}
          >
            {`{{${name}}}`}
          </Flex>
        </WrapItem>
      ))}
    </Wrap>
  );
};

export default VariableChips;
